/**
 * The filename an employee sees when they download a payslip.
 *
 * Run number and employee code are the two identifiers already printed on the
 * document, so the file sorts with the payroll register and cannot be confused
 * with another employee's payslip.
 */
export function payslipFilename(item: {
  run_number?: string | null;
  employee_code?: string | null;
}): string {
  const parts = [item.run_number, item.employee_code]
    .map((part) => (part ?? "").trim())
    .filter(Boolean);
  return `${parts.join("-") || "payslip"}.pdf`;
}
